module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/spatula-92f1673ebb85b82f511933ddd1944cf7.svg";